<div class="card panel-monsido-card seo-summary-opportunities-in-category">
    <div class="card-header">
        <h2 class="font-weight-300 mb-1" translate>
            Affected pages by priority
        </h2>
        <span class="text-grey" translate>
            Distribution of SEO levels
        </span>
    </div>
    <div class="card-body">
        <div class="row">
            <div *ngFor="let category of seoCategories; trackBy: trackByIndex" class="col-lg-24 col-md-48 mb-4 inline-block">
                <div class="col-24 inline-block col-middle remove-float pr-0">
                    <mon-chart-doughnut [labels]="labels"
                                    [colors]="category.colors"
                                    [options]="category.options"
                                    [data]="category.data"
                                    [size]="'120'"
                    ></mon-chart-doughnut>
                </div>
                <div class="col-23 inline-block col-middle remove-float">
                    <div class="text-grey mb-1">
                        <span class="fas fa-circle" [ngClass]="category.color"></span>
                        {{ category.title }}
                    </div>
                    <p class="mb-1">
                        <span class="fas fa-window-maximize text-turqoise pr-1"
                              ngbTooltip="{{ 'Pages in compliance' | translate }}"
                              [triggers]="'focus hover'">
                        </span>
                        <strong>{{ category.inCompliance | monNumber }}</strong>
                    </p>
                    <p>
                        <span class="fas fa-window-maximize text-grey pr-1"
                              ngbTooltip="{{ 'Pages needing to be fixed' | translate }}"
                              [triggers]="'focus hover'">
                        </span>
                        <strong>{{ category.errors | monNumber }}</strong>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
